import React, { useRef, useState } from "react";
import styled from "styled-components";
import { isPasswordValid, passwordsMatch } from "../../helper/ValidatorsHelper";
import { useNavigate, useOutletContext } from "react-router-dom";
import CustomInput from "../../Components/Generic/CustomInput";
import CustomModal from "../../Components/Generic/CustomModal";
import { useUserContext } from "../../context/useUserContext";
import { showGenericError } from "../../helper/Notifications";
import { ReactComponent as ShowIcon } from "../../assets/icons/ShowIcon.svg";
import { ReactComponent as ShowIconDisabled } from "../../assets/icons/ShowIconDisabled.svg";
import ReactPasswordChecklist from "react-password-checklist";


const ChangePasswordCard = ({ setIsModalOpen }) => {
    const { changePassword, user } = useUserContext();

    const navigate = useNavigate();
    const { setLoading } = useOutletContext()
    const initialValues = {
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: "",
        otpCode: "",
    };

    const [inputValues, setInputvalues] = useState(initialValues);
    const [passwordRulesValid, setPasswordRulesValid] = useState(false);
    const [showConditions, setShowConditions] = useState(false);


    const oldPasswordRef = useRef(null);
    const passwordRef = useRef(null);
    const passwordConfRef = useRef(null);
    const [showOldPwd, setShowOldPwd] = useState(false);
    const [showNewPwd, setShowNewPwd] = useState(false);
    const [showConfPwd, setShowConfPwd] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputvalues({
            ...inputValues,
            [name]: value,
        });
    };

    const handleResetBtn = () => {
        let otpValid = true;

        if (!passwordRulesValid) {
            setShowConditions(true);
            return
        }

        if (user.otp_required_for_login) {
            otpValid = inputValues.otpCode.length > 5
        }


        if (
            isPasswordValid(inputValues.newPassword) &&
            passwordsMatch(inputValues.newPassword, inputValues.newPasswordConfirm) &&
            passwordRulesValid &&
            otpValid
        ) {
            setLoading(true);
            changePassword(
                inputValues.oldPassword,
                inputValues.newPassword,
                inputValues.otpCode,
                () => {
                    setLoading(false);
                    navigate("/login", { replace: true });
                },
                (error) => {
                    showGenericError();
                    setLoading(false);
                }
            );
        }
    };

    return (
        <CustomModal
            isOpen={true}
            onOpenChange={(open) => !open && setIsModalOpen(false)}
            iconType="key"
            iconAlignment="left"
            title="Change password"
            subtitle="Pick a new password to use for your login credentials."
            buttons={[
                { text: "Cancel", variant: "secondary", onClick: () => setIsModalOpen(false) },
                {
                    text: "Change Password",
                    variant: "primary",
                    onClick: handleResetBtn,
                    disabled: !(isPasswordValid(inputValues.newPassword) && isPasswordValid(inputValues.newPasswordConfirm)),
                },
            ]}
        >
            <div className="flex flex-col gap-4 text-left">
                <div className="flex flex-col gap-4">

                    <CustomInput
                        type={showOldPwd ? "text" : "password"}
                        label={"Current password"}
                        placeholder="Enter your current password"
                        name={"oldPassword"}
                        value={inputValues.oldPassword}
                        onChange={handleInputChange}
                        inputRef={oldPasswordRef}
                        customButton={
                            <ShowPasswordBtn
                                onClick={() => setShowOldPwd((v) => !v)}
                                aria-label="Toggle password visibility"
                            >
                                {showOldPwd ? <ShowIcon /> : <ShowIconDisabled />}
                            </ShowPasswordBtn>
                        }
                    />

                    <CustomInput
                        type={showNewPwd ? "text" : "password"}
                        label={"New password"}
                        placeholder="Enter a new password"
                        name={"newPassword"}
                        value={inputValues.newPassword}
                        onChange={handleInputChange}
                        inputRef={passwordRef}
                        customButton={
                            <ShowPasswordBtn
                                onClick={() => setShowNewPwd((v) => !v)}
                                aria-label="Toggle password visibility"
                            >
                                {showNewPwd ? <ShowIcon /> : <ShowIconDisabled />}
                            </ShowPasswordBtn>
                        }
                    />

                    <CustomInput
                        type={showConfPwd ? "text" : "password"}
                        label={"Retype password"}
                        placeholder="Retype your new password"
                        name={"newPasswordConfirm"}
                        value={inputValues.newPasswordConfirm}
                        onChange={handleInputChange}
                        inputRef={passwordConfRef}
                        customButton={
                            <ShowPasswordBtn
                                onClick={() => setShowConfPwd((v) => !v)}
                                aria-label="Toggle password visibility"
                            >
                                {showConfPwd ? <ShowIcon /> : <ShowIconDisabled />}
                            </ShowPasswordBtn>
                        }
                    />

                    {user.otp_required_for_login &&
                        <CustomInput
                            type={"text"}
                            label={"Verification code"}
                            placeholder="Enter OTP code"
                            name={"otpCode"}
                            value={inputValues.otpCode}
                            onChange={handleInputChange}
                        />
                    }

                    <div style={showConditions ? { display: "flex" } : { display: "none" }}>
                        <ReactPasswordChecklist
                            iconSize={14}
                            minLength={6}
                            value={inputValues.newPassword}
                            valueAgain={inputValues.newPasswordConfirm}
                            rules={["minLength", "specialChar", "capital", "lowercase", "number", "match"]}
                            onChange={(isValid) => { setPasswordRulesValid(isValid) }}
                            className="password-rules"
                        />

                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default ChangePasswordCard;

const ShowPasswordBtn = styled.button`
border:none;
background:none;
cursor:pointer;
display:flex;
align-items:center;
jutify-content:center;
padding: 0;
height: 20px;
width: 20px;

&:disabled{
  cursor: not-allowed;
}
`

// removed KeyIcon since the modal now renders built-in icons by type
